import { Component } from "react"
import { Redirect, Route, RouteProps } from "react-router-dom"
import UserAccessSettings from "../authentication/UserAccessSettings"
import UserState from "../authentication/UserState"
import HasAccessToRoute, { HasAccessToAtLeastOneRoute } from "../authentication/hasAccessToRoute"
import { Home } from "../config/Routes"

export interface ProtectedRouteProps {
  userAccess: UserAccessSettings
  userState: UserState
}

export default class ProtectedRoute extends Component<ProtectedRouteProps & RouteProps>{
  render() {
    const { path, userAccess, userState } = this.props
    const hasAccess = !!path && Array.isArray(path)
      ? HasAccessToAtLeastOneRoute(path, userAccess, userState)
      : HasAccessToRoute(path as string | undefined, userAccess, userState)
    return hasAccess ? <Route {...this.props} /> : <Redirect to={Home} />
  }
}
